import { render, staticRenderFns } from "./InsightCard.vue?vue&type=template&id=51e1a34d&scoped=true"
import script from "./InsightCard.vue?vue&type=script&lang=js"
export * from "./InsightCard.vue?vue&type=script&lang=js"
import style0 from "./InsightCard.vue?vue&type=style&index=0&id=51e1a34d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e1a34d",
  null
  
)

export default component.exports